<template>
  <b-modal
    id="reset-password-modal"
    ref="modal"
    title=""
    hide-footer
    hide-header
    centered
  >
    <div class="header">
      <span class="close-icon" @click="closeModal">
        <img src="@/assets/svg/close.svg" aria-label="close" />
      </span>

      <h3>
        восстановление <br />
        пароля
      </h3>
    </div>

    <form ref="form" class="modal-form" @submit.stop.prevent="submit">
      <b-form-group label-for="phone-input" :invalid-feedback="invalidPhone">
        <b-form-input
          id="phone-input"
          placeholder="Email"
          v-model="$v.item.email.$model"
          :class="{ 'is-invalid': isInvalidPhone, 'is-valid': !isInvalidPhone }"
          :state="validateState($v.item.email)"
          required
        ></b-form-input>
      </b-form-group>

      <div class="w-100 d-flex justify-content-center">
        <div id="captcha-container-reset"></div>

        <!-- <vue-recaptcha sitekey="ysc1_cS8OaHyfLaHdYM7azFhnM84ck956BhgzOAVycwjgc9863942"
                        :loadRecaptchaScript="true"
                        class="captcha"
                        size="99%"
                        ref="recaptcha"
                        @verify="onCaptchaVerified"
                        v-model="$v.item.recaptchaResponse.$model"
                        :state="validateState($v.item.recaptchaResponse)"
         ></vue-recaptcha> -->
      </div>

      <span v-if="isInvalidCaptcha" class="invalid-text">{{
        this.invalidCaptcha
      }}</span>
    </form>

    <b-button
      class="button button-green button-green-bg"
      type="submit"
      :disabled="disabledBtn"
      onclick="ym(108239013,'reachGoal', 'recover_password')"
      @click="submit"
      >Отправить пароль</b-button
    >
  </b-modal>
</template>

<script>
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";
import { validationMixin } from "vuelidate";
import { mapGetters, mapMutations } from "vuex";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  or,
  helpers,
} from "vuelidate/lib/validators";

const number = helpers.regex(
  "number",
  /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
);
const email = helpers.regex("email", /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
const token = localStorage.getItem("token-bockarev");

export default {
  props: ["authText", "authPhone"],

  components: {
    VueRecaptcha,
  },

  mixins: [validationMixin],

  validations: {
    item: {
      phone: {
        minLength: minLength(17),
        maxLength: maxLength(17),
      },
      email: {
        required,
        minLength: minLength(4),
        email,
      },
      recaptchaResponse: {},
    },
  },

  data() {
    return {
      item: {
        phone: "",
        email: "",
        recaptchaResponse: "",
      },
      widgetId: null,
      recaptcha: null,
      isInvalidPhone: false,
      invalidPhone: "Некорректное поле",
      isInvalidCaptcha: false,
      invalidCaptcha: "Некорректное поле",
    };
  },

  computed: {
    disabledBtn() {
      if (this.$v.item.$anyError) return true;
    },
  },

  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "reset-password-modal") {
        setTimeout(() => {
          if (window.smartCaptcha) {
            this.renderCaptcha();
          } else {
            window.onSmartCaptchaLoad = this.renderCaptcha;
          }
        }, 500);
      }
    });
  },

  methods: {
    resetModal() {
      this.$v.$reset();

      ((this.item.phone = ""),
        (this.item.email = ""),
        (this.item.recaptchaResponse = ""),
        (this.isInvalidPhone = false),
        (this.invalidPhone = "Некорректное поле"),
        (this.isInvalidCaptcha = false),
        (this.invalidCaptcha = "Некорректное поле"));

      this.$bvModal.hide("reset-password-modal");

      this.$emit("getThanksTitle", "Пароль отправлен");
      this.$emit(
        "getThanksText",
        "Ваш пароль для входа был отправлен на электронную почту, указанную при регистрации.",
      );
      this.$bvModal.show("thanks-modal");
    },

    putPlaceholder() {
      if (this.item.phone.length < 2) {
        this.item.phone = "+7";
      }
    },

    renderCaptcha() {
      this.widgetId = window.smartCaptcha.render("captcha-container-reset", {
        sitekey: "ysc1_cS8OaHyfLaHdYM7azFhnM84ck956BhgzOAVycwjgc9863942",
        callback: this.onCaptchaPassed,
      });
    },

    onCaptchaPassed(token) {
      this.item.recaptchaResponse = token; // Store token for form submission
      this.$emit("validated", token);
    },

    resetCaptcha() {
      if (this.widgetId !== null) {
        window.smartCaptcha.reset(this.widgetId); // Reset for reuse
      }
    },

    closeModal() {
      this.$v.$reset();

      ((this.item.phone = ""),
        (this.item.email = ""),
        (this.item.recaptchaResponse = ""),
        (this.isInvalidPhone = false),
        (this.invalidPhone = "Некорректное поле"),
        (this.isInvalidCaptcha = false),
        (this.invalidCaptcha = "Некорректное поле"));

      this.$bvModal.hide("reset-password-modal");
    },

    validateState(item) {
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },

    onCaptchaVerified(recaptchaToken) {
      this.item.recaptchaResponse = recaptchaToken;
    },

    submit() {
      this.$v.item.$touch();

      if (this.$v.item.$anyError) return false;

      axios
        .post(
          "auth/forgot",
          {
            email: this.item.email,
            "smart-captcha-response": this.item.recaptchaResponse,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
            },
          },
        )
        .then((response) => {
          ym(108239013, "reachGoal", "recover_password_send");
          this.resetModal();
        })
        .catch((error) => {
          if (
            error.response.data.message ===
            "С момента прошлого запроса не прошло 5 минут"
          ) {
            this.$emit("getErrorText", error.response.data.message);

            this.closeModal();
            this.$bvModal.show("error-modal");
          }
          if (
            error.response.data.message &&
            error.response.data.errors &&
            !error.response.data.errors.phone
          ) {
            this.isInvalidCaptcha = true;
            this.invalidCaptcha = "Заполните поле";
          }
          if (error.response.data.errors.phone) {
            this.isInvalidPhone = true;
            this.invalidPhone = error.response.data.errors.phone[0];
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  margin-top: 40px;
  width: 100%;

  &:hover {
    opacity: 0.8 !important;
  }

  @media (max-width: 576px) {
    margin-top: 15px;
  }
}

.header {
  margin-bottom: 30px;

  h3 {
    margin-top: 60px !important;
  }
}

h5 {
  text-align: center;
  margin-top: -30px;
  font-size: 16px;
  color: $black;
  font-weight: 400;
}

.modal-form {
  padding: 0px !important;
}

a {
  color: $red;
}

.captcha {
  display: flex;
  justify-content: center;
  width: 100% !important;
  transform: scale(125%);
  margin-top: 20px;
  margin-bottom: 20px;

  @media (max-width: 400px) {
    transform: scale(100%);
  }

  @media (max-width: 350px) {
    transform: scale(90%);
  }
}

.invalid-text {
  color: $red;
  font-size: 11px;
  margin-left: 10px;
  margin-top: -5px;
}
</style>
